import {
  Area,
  AreaChart,
  CartesianGrid,
  Label,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'

import ChartBox from '../ChartBox/index'
import { chartMainColor } from '../chartHelpers'
import InsightsTooltip from '../InsightsTooltip/index'

const LineCard = ({ title, subtitle, data, xLabel, yLabel, height = 300, unit }) => (
  <ChartBox>
    <ChartBox.Header title={title} subtitle={subtitle} />
    <ChartBox.Content>
      <ResponsiveContainer width="100%" height={height}>
        <AreaChart
          data={data}
          barGap={2}
          margin={{
            top: 30
          }}
        >
          <XAxis
            dataKey="name"
            axisLine={{ stroke: '#F2F2F2', strokeWidth: 1 }}
            tick={{
              fill: '#7D7D7D',
              fontSize: 12,
              transform: 'translate(0, 14)'
            }}
            tickSize={0}
            padding={{ top: 30, bottom: 20, right: xLabel ? 40 : 0 }}
          >
            {xLabel && (
              <Label
                value={xLabel}
                position="insideBottomRight"
                fontSize="12"
                fontWeight={500}
                fill="#7D7D7D"
                offset={6}
              />
            )}
          </XAxis>
          <YAxis
            tickSize={0}
            axisLine={false}
            tick={{
              fill: '#7D7D7D',
              fontSize: 12,
              transform: 'translate(-10, 0)'
            }}
            padding={{ top: yLabel ? 18 : 0, bottom: 0 }}
          >
            {yLabel && (
              <Label
                value={yLabel}
                position="top"
                fontSize="12"
                fontWeight={500}
                offset={18}
                fill="#7D7D7D"
              />
            )}
          </YAxis>
          <CartesianGrid stroke="#F2F2F2" vertical={false} />
          <Tooltip content={InsightsTooltip} />
          {Object.keys(data[0])
            .filter(k => k !== 'name')
            .map(k => (
              <Area
                type="linear"
                dataKey={k}
                stroke={chartMainColor}
                strokeWidth={2}
                fill="#4079F5"
                fillOpacity={0.07}
                key={`area-${k}`}
                unit={unit}
              />
            ))}
        </AreaChart>
      </ResponsiveContainer>
    </ChartBox.Content>
  </ChartBox>
)
export default LineCard
